import onboardingPauseAndReward from '../assets/images/onboardingPauseAndReward.png'
import onboardingPauseAndReward2x from '../assets/images/onboardingPauseAndReward@2x.png'

/**
 * OnboardingPauseAndRewardIcon Component
 *
 * Displays the pause and reward icon for the second onboarding slide.
 * Supports retina displays with @2x image asset.
 *
 * @example
 * <OnboardingPauseAndRewardIcon />
 */
export const OnboardingPauseAndRewardIcon = () => {
  return (
    <img
      src={onboardingPauseAndReward}
      srcSet={`${onboardingPauseAndReward} 1x, ${onboardingPauseAndReward2x} 2x`}
      alt="Pause and reward yourself"
      className="onboarding-icon"
      width={148}
      height={148}
    />
  )
}
